import Vue from "vue";
import VueRouter from "vue-router";

let originPush = VueRouter.prototype.push;
let originReplace = VueRouter.prototype.replace;

VueRouter.prototype.push = function push(location) {
  return originPush.call(this, location).catch((err) => err);
};
VueRouter.prototype.replace = function push(location) {
  return originReplace.call(this, location).catch((err) => err);
};

import Layout from "@/views/layout/index.vue";

Vue.use(VueRouter);

const asyncRouter = [
  {
    path: "/",
    component: Layout,
    meta: { title: "首页", icon: "dashboard", noCache: true },
    group: true,
    children: [
      {
        path: "/dashboard",
        component: () => import("@/views/dashboard/index"),
        name: "dashboard",
        meta: { title: "首页", prefix: "/dashboard" },
      },
      // {
      //   path: "/p/dashboard",
      //   component: () => import("@/views/dashboard/index2"),
      //   name: "dashboard2",
      //   meta: { title: "首页", prefix: "/dashboard2" },
      // },
      {
        path: "/planet/list",
        component: () => import("@/views/planet/list"),
        name: "planetList",
        meta: { title: "星球列表", prefix: "/planet" },
      },
      {
        path: "/acquisition/sms",
        component: () => import("@/views/acquisition/sms.vue"),
        name: "acquisitionSms",
        meta: { title: "短信配置", prefix: "/acquisition" },
      },
      {
        path: "/acquisition/douyin",
        component: () => import("@/views/acquisition/douyin.vue"),
        name: "acquisitionDouyin",
        meta: { title: "抖音获客", prefix: "/acquisition" },
      },
      // {
      //   path: "/p/planet/list",
      //   component: () => import("@/views/planet/list"),
      //   name: "planetList",
      //   meta: { title: "星球列表", prefix: "/planet" },
      // },
      // {
      //   path: "/p/planet/enterGroupList",
      //   component: () => import("@/views/planet/enterGroupList"),
      //   name: "enterGroupList",
      //   meta: { title: "配置一键进群", prefix: "/planet" },
      // },
      // {
      //   path: "/p/planet/columnGiftList",
      //   component: () => import("@/views/planet/columnGiftList"),
      //   name: "columnGiftList",
      //   meta: { title: "买星球赠课", prefix: "/planet" },
      // },
      // {
      //   path: "/p/planet/messageMention",
      //   component: () => import("@/views/planet/messageMention"),
      //   name: "messageMention",
      //   meta: { title: "配置短信提醒", prefix: "/planet" },
      // },
      // {
      //   path: "/p/planet/wxGroup",
      //   component: () => import("@/views/planet/tools/wxGroup"),
      //   name: "wxGroup",
      //   meta: { title: "配置微信群", prefix: "/planet" },
      // },
      // {
      //   path: "/p/planet/book",
      //   component: () => import("@/views/planet/book.vue"),
      //   name: "planetBook",
      //   meta: { title: "配置微信群", prefix: "/planet" },
      // },
      // {
      //   path: "/p/course/video",
      //   title: "视频课",
      //   component: () => import("@/views/course/planetVideo"),
      //   name: "videoCourse",
      //   meta: { title: "视频课" },
      // },
      // {
      //   path: "/p/course/video/create",
      //   title: "视频课",
      //   component: () => import("@/views/course/planetCreateCourse"),
      //   name: "createVideoCourse",
      //   meta: { title: "视频课" },
      // },
      // {
      //   path: "/p/course/video/manage",
      //   title: "课程管理",
      //   component: () => import("@/views/course/planetCourseManage"),
      //   name: "manageVideoCourse",
      //   meta: { title: "课程管理" },
      // },
      // {
      //   path: "/p/marketing/coupon",
      //   component: () => import("@/views/marketing/coupon2"),
      //   name: "coupon",
      //   meta: { title: "优惠券" },
      // },
      // {
      //   path: "/p/marketing/distribution",
      //   component: () => import("@/views/planet/distribution"),
      //   name: "marketingDistribution",
      //   meta: { title: "限时抢购" },
      // },
      // {
      //   path: "/p/marketing/limited",
      //   component: () => import("@/views/planet/views/limited"),
      //   name: "limitedSale",
      //   meta: { title: "限时抢购" },
      // },
      // {
      //   path: "/p/marketing/limited/create",
      //   component: () => import("@/views/planet/views/limitedEdit"),
      //   name: "createLimitedSale",
      //   meta: { title: "设置限时抢购" },
      // },
      // {
      //   path: "/p/marketing/page",
      //   component: () => import("@/views/marketing/page"),
      //   name: "editPacket",
      //   meta: { title: "店铺装修" },
      // },
      // {
      //   path: "/p/order/center",
      //   component: () => import("@/views/order/orderList"),
      //   name: "orderPlanetCenter",
      //   meta: { title: "销售订单" },
      // },
      // {
      //   path: "/p/order/manage",
      //   component: () => import("@/views/order/manage"),
      //   name: "orderManage",
      //   meta: { title: "抖店订单" },
      // },
      // {
      //   path: "/p/aftersale/index",
      //   component: () => import("@/views/planet/aftersale"),
      //   name: "aftersale",
      //   meta: { title: "退款订单" },
      // },
      // {
      //   path: "/p/aftersale/appeal",
      //   component: () => import("@/views/aftersale/appeal"),
      //   name: "appeal",
      //   meta: { title: "客户申诉" },
      // },
      // {
      //   path: "/p/user/index",
      //   component: () => import("@/views/user/index"),
      //   name: "userList",
      //   meta: { title: "用户列表", noCache: true },
      // },
      // {
      //   path: "/p/accounting/detail",
      //   component: () => import("@/views/accounting/index"),
      //   name: "accountingDetail",
      //   meta: { title: "资金明细" },
      // },
      // {
      //   path: "/p/accounting/balance",
      //   component: () => import("@/views/accounting/takeout"),
      //   name: "accountingBalance",
      //   meta: { title: "提现管理" },
      // },
      // {
      //   path: "/p/setting/self",
      //   component: () => import("@/views/setting/self"),
      //   name: "accountingSetting",
      //   meta: { title: "账号设置" },
      // },
      // {
      //   path: "/p/setting/accounting",
      //   component: () => import("@/views/setting/manage2"),
      //   name: "PlanetAccountingManage",
      //   meta: { title: "账号管理" },
      // },
      // {
      //   path: "/p/setting/record",
      //   component: () => import("@/views/setting/record"),
      //   name: "record",
      //   meta: { title: "导出记录" },
      // },
      // {
      //   path: "/p/setting/role",
      //   component: () => import("@/views/setting/role"),
      //   name: "accountingRole",
      //   meta: { title: "角色管理" },
      // },
      // {
      //   path: "/p/setting/index2",
      //   component: () => import("@/views/setting/index2"),
      //   name: "zizhi2",
      //   meta: { title: "抖音资质", prefix: "/setting" },
      //   hidden: true,
      // },
      // {
      //   path: "/p/setting/accounting/qualification",
      //   component: () => import("@/views/setting/qualification"),
      //   name: "qualification",
      //   meta: { title: "资质认证", prefix: "/setting/accounting" },
      //   hidden: true,
      // },
      // {
      //   path: "/p/setting/myRoleApply",
      //   component: () => import("@/views/setting/roleApply"),
      //   name: "roleApply",
      //   meta: { title: "角色申请" },
      // },
      // {
      //   path: "/p/setting/roleBaseInfoApply",
      //   component: () => import("@/views/setting/roleBaseInfoApply"),
      //   name: "roleBaseInfoApply",
      //   meta: { title: "角色基础申请" },
      // },
      // {
      //   path: "/p/setting/roleClassInfoApply",
      //   component: () => import("@/views/setting/roleClassInfoApply"),
      //   name: "roleClassInfoApply",
      //   meta: { title: "角色类目申请" },
      // },
      // {
      //   path: "/p/setting/roleAuthInfoApply",
      //   component: () => import("@/views/setting/roleAuthInfoApply"),
      //   name: "roleAuthInfoApply",
      //   meta: { title: "角色授权申请" },
      // },
      // {
      //   path: "/p/setting/index",
      //   component: () => import("@/views/setting/index"),
      //   name: "ttScope",
      //   meta: { title: "抖音账号管理" },
      // },
      // {
      //   path: "/p/setting/ttScope",
      //   component: () => import("@/views/setting/ttScope"),
      //   name: "SettingTtScope",
      //   meta: { title: "抖音账号管理" },
      // },
      // {
      //   path: "/p/planet/information",
      //   component: () => import("@/views/planet/information"),
      //   name: "PlanetInformation",
      //   meta: { title: "认证讲师" },
      // },
      // {
      //   path: "/p/planet/identificationApply",
      //   component: () => import("@/views/planet/identificationApply"),
      //   name: "PlanetIdentificationApply",
      //   meta: { title: "完善讲师认证资料" },
      // },
      // {
      //   path: "/p/planet/IdentificationSuccess",
      //   component: () => import("@/views/planet/IdentificationSuccess"),
      //   name: "PlanetIdentificationSuccess",
      //   meta: { title: "讲师认证审核" },
      // },
      // {
      //   path: "/p/setting/guide",
      //   component: () => import("@/views/setting/guide"),
      //   name: "guide",
      //   meta: { title: "入驻引导" },
      // },
      // {
      //   path: "/p/setting/enterpriseBaseInfoApply",
      //   component: () => import("@/views/setting/enterpriseBaseInfoApply"),
      //   name: "enterpriseBaseInfoApply",
      //   meta: { title: "企业角色基础申请" },
      // },
      // {
      //   path: "/p/setting/enterpriseClassInfoApply",
      //   component: () => import("@/views/setting/enterpriseClassInfoApply"),
      //   name: "enterpriseClassInfoApply",
      //   meta: { title: "企业类目申请" },
      // },
      // {
      //   path: "/p/setting/enterpriseAuthInfoApply",
      //   component: () => import("@/views/setting/enterpriseAuthInfoApply"),
      //   name: "enterpriseAuthInfoApply",
      //   meta: { title: "企业角色授权申请" },
      // },
    ],
  },
  // 课程
  //     视频课
  //     组合课
  {
    path: "/course",
    component: Layout,
    meta: { title: "课程管理", icon: "course" },
    children: [
      {
        path: "/course/column",
        component: () => import("@/views/course/column"),
        name: "column",
        meta: { title: "专栏管理" },
      },
      {
        path: "/course/private",
        component: () => import("@/views/course/video"),
        name: "private",
        meta: { title: "私教管理" },
      },
      {
        path: "/course/service",
        component: () => import("@/views/course/video"),
        name: "service",
        meta: { title: "服务管理" },
      },
      {
        path: "/course/audio",
        component: () => import("@/views/course/audio"),
        name: "audio",
        meta: { title: "音频课" },
      },
      {
        path: "/course/richtext",
        component: () => import("@/views/course/richtext"),
        name: "richtext",
        meta: { title: "图文课" },
      },
      {
        path: "/course/mixture",
        component: () => import("@/views/course/mixture"),
        name: "mixture",
        meta: { title: "套餐课" },
      },
    ],
  },
  // 教学管理
  //     教学资料
  {
    path: "/teach",
    component: Layout,
    meta: { title: "教学管理", icon: "teaching", noCache: true },
    children: [
      {
        path: "/teach/teacher",
        component: () => import("@/views/teaching/teacher"),
        name: "teacher",
        meta: { title: "讲师管理", noCache: true },
      },
      {
        path: "/teach/book",
        component: () => import("@/views/teaching/book"),
        name: "book",
        meta: { title: "教学资料", noCache: true },
      },
      {
        path: "/teach/courseware",
        component: () => import("@/views/teaching/courseware"),
        name: "courseware",
        meta: { title: "课件", noCache: true },
      },
    ],
  },
  // 互动
  {
    path: "/interaction",
    component: Layout,
    meta: { title: "互动管理", icon: "teaching", noCache: true },
    children: [
      {
        path: "/interaction/punch",
        component: () => import("@/views/interaction/punch"),
        name: "teacher",
        meta: { title: "打卡", noCache: true },
      },
      {
        path: "/interaction/exam",
        component: () => import("@/views/interaction/exam"),
        name: "book",
        meta: { title: "考试", noCache: true },
      },
      {
        path: "/interaction/practice",
        component: () => import("@/views/interaction/practice"),
        name: "courseware",
        meta: { title: "练习", noCache: true },
      },
      {
        path: "/interaction/homework",
        component: () => import("@/views/interaction/homework"),
        name: "teacher",
        meta: { title: "作业本", noCache: true },
      },
      {
        path: "/interaction/question",
        component: () => import("@/views/interaction/question"),
        name: "book",
        meta: { title: "题库", noCache: true },
      },
      {
        path: "/interaction/cert",
        component: () => import("@/views/interaction/cert"),
        name: "courseware",
        meta: { title: "证书", noCache: true },
      },
      {
        path: "/interaction/detection",
        component: () => import("@/views/interaction/detection"),
        name: "teacher",
        meta: { title: "随堂检测", noCache: true },
      },
      {
        path: "/interaction/test",
        component: () => import("@/views/interaction/test"),
        name: "book",
        meta: { title: "测试互动", noCache: true },
      },
      {
        path: "/interaction/qapayment",
        component: () => import("@/views/interaction/qapayment"),
        name: "courseware",
        meta: { title: "付费问答", noCache: true },
      },
      {
        path: "/interaction/comment",
        component: () => import("@/views/interaction/comment"),
        name: "courseware",
        meta: { title: "评论管理", noCache: true },
      },
    ],
  },
  // 用户管理
  {
    path: "/user",
    component: Layout,
    meta: { title: "用户管理", icon: "user", noCache: true },
    children: [
      {
        path: "/user/dashboard",
        component: () => import("@/views/user/dashboard"),
        name: "userDashboard",
        meta: { title: "用户概况", noCache: true },
      },
      {
        path: "/user/index",
        component: () => import("@/views/user/index"),
        name: "userList",
        meta: { title: "用户列表", noCache: true },
      },
      {
        path: "/user/tags",
        component: () => import("@/views/user/tags"),
        name: "userList",
        meta: { title: "标签管理", noCache: true },
      },
      {
        path: "/user/groups",
        component: () => import("@/views/user/groups"),
        name: "userGroups",
        meta: { title: "群聊管理", noCache: true },
      },
    ],
  },

  // 客户与员工管理
  {
    path: "/manage",
    component: Layout,
    meta: { title: "SCRM", icon: "scrm", noCache: true },
    children: [
      {
        path: "/manage/customer",
        component: () => import("@/views/manage/customer.vue"),
        name: "manageCustomer",
        meta: { title: "客户管理", noCache: true },
      },
      {
        path: "/manage/user",
        component: () => import("@/views/manage/user.vue"),
        name: "manageUser",
        meta: { title: "员工管理", noCache: true },
      },
      {
        path: "/manage/tags",
        component: () => import("@/views/manage/customerTag.vue"),
        name: "manageCustomerTag",
        meta: { title: "客户标签", noCache: true },
      },
    ],
  },

  // 获客配置
  {
    path: "/acquisition",
    component: Layout,
    meta: { title: "获客配置", icon: "hoke", noCache: true },
    children: [
      {
        path: "/acquisition/sms",
        component: () => import("@/views/acquisition/sms.vue"),
        name: "acquisitionSms",
        meta: { title: "短信配置", noCache: true },
      },
      {
        path: "/acquisition/douyin",
        component: () => import("@/views/acquisition/douyin.vue"),
        name: "acquisitionDouyin",
        meta: { title: "抖音获客", noCache: true },
      },
    ],
  },

  // 数据中心
  //     课程分析
  //     学员分析
  //     直播分析
  {
    path: "/database",
    component: Layout,
    meta: { title: "数据中心", icon: "database", noCache: true },
    children: [
      {
        path: "/database/course",
        component: () => import("@/views/database/course"),
        name: "databaseCourse",
        meta: { title: "课程分析", noCache: true },
      },
      {
        path: "/database/student",
        component: () => import("@/views/database/student"),
        name: "databaseStudent",
        meta: { title: "学员分析", noCache: true },
      },
      {
        path: "/database/living",
        component: () => import("@/views/database/living"),
        name: "databaseLiving",
        meta: { title: "直播分析", noCache: true },
      },
      {
        path: "/database/costomer",
        component: () => import("@/views/database/costomer"),
        name: "databaseCostomer",
        meta: { title: "潜客分析", noCache: true },
      },
    ],
  },
  // 营销工具
  //     优惠券
  //     限时抢购
  {
    path: "/marketing",
    component: Layout,
    meta: { title: "营销工具", icon: "tool" },
    group: true,
    children: [
      {
        path: "/marketing/coupon",
        component: () => import("@/views/marketing/coupon"),
        name: "coupon",
        meta: { title: "优惠券" },
      },
      {
        path: "/marketing/limited",
        component: () => import("@/views/marketing/limited"),
        name: "limited",
        meta: { title: "限时抢购" },
      },
      // {
      //   path: "/marketing/shopwin",
      //   component: () => import("@/views/marketing/shopwin"),
      //   name: "shopwin",
      //   meta: { title: "直播橱窗" },
      // },
    ],
  },
  // {
  //   path: "/p",
  //   component: Layout,
  //   meta: { title: "营销工具", icon: "tool" },
  //   group: true,
  //   children: [
  //     {
  //       path: "/p/marketing/coupon",
  //       component: () => import("@/views/marketing/coupon"),
  //       name: "coupon",
  //       meta: { title: "优惠券" },
  //     },
  //     {
  //       path: "/p/marketing/limited",
  //       component: () => import("@/views/marketing/limited"),
  //       name: "limited",
  //       meta: { title: "限时抢购" },
  //     },
  //   ],
  // },
  // 订单管理
  {
    path: "/order",
    component: Layout,
    meta: { title: "订单管理", icon: "order" },
    children: [
      {
        path: "/order/center",
        component: () => import("@/views/order/center"),
        name: "orderCenter",
        meta: { title: "销售订单" },
      },
      {
        path: "/order/manage",
        component: () => import("@/views/order/manage"),
        name: "orderManage",
        meta: { title: "抖店订单" },
      },
    ],
  },
  // 素材中心
  {
    path: "/source",
    component: () => import("@/views/sources/index"),
    meta: { title: "素材管理", icon: "source" },
  },
  // 全域获客
  {
    path: "/platform",
    meta: { title: "素材管理", icon: "source" },
  },
  {
    path: "/traffic",
    component: () => import("@/views/sources/traffic"),
    name: "traffic",
    meta: { title: "流量中心" },
  },
  {
    path: "/package",
    component: () => import("@/views/sources/package"),
    name: "package",
    meta: { title: "版本套餐" },
  },
  // 售后管理
  {
    path: "/aftersale",
    component: Layout,
    meta: { title: "售后管理", icon: "aftersale", noCache: true },
    children: [
      {
        path: "/aftersale/index",
        component: () => import("@/views/aftersale/index"),
        name: "aftersale",
        meta: { title: "退款订单" },
      },
      {
        path: "/aftersale/appeal",
        component: () => import("@/views/aftersale/appeal"),
        name: "appeal",
        meta: { title: "客户申诉" },
      },
    ],
  },
  // 资金收益
  {
    path: "/accounting",
    component: Layout,
    meta: { title: "资金收益", icon: "accounting", noCache: true },
    children: [
      {
        path: "/accounting/detail",
        component: () => import("@/views/accounting/index"),
        name: "accountingDetail",
        meta: { title: "资金明细" },
      },
      {
        path: "/accounting/balance",
        component: () => import("@/views/accounting/capitalIncome"),
        name: "accountingBalance",
        meta: { title: "提现管理" },
      },
    ],
  },
  {
    path: "/setting",
    component: Layout,
    meta: { title: "系统设置", icon: "setting" },
    children: [
      {
        path: "/setting/self",
        component: () => import("@/views/setting/self"),
        name: "accountingSetting",
        meta: { title: "账号设置" },
      },
      {
        path: "/setting/accounting",
        component: () => import("@/views/setting/manage"),
        name: "accountingManage",
        meta: { title: "账号管理" },
      },
      {
        path: "/setting/record",
        component: () => import("@/views/setting/record"),
        name: "record",
        meta: { title: "导出记录" },
      },
      {
        path: "/setting/role",
        component: () => import("@/views/setting/role"),
        name: "accountingRole",
        meta: { title: "角色管理" },
      },
      {
        path: "/setting/api",
        component: () => import("@/views/setting/api"),
        name: "accountingAPI",
        meta: { title: "开发设置" },
      },
    ],
  },
];

const routes = [
  {
    path: "/login",
    component: () => import("@/views/login/index"),
    name: "login",
    hidden: true,
  },
  {
    path: "/register",
    component: () => import("@/views/login/register"),
    name: "register",
    hidden: true,
  },
  {
    path: "/p/login",
    component: () => import("@/views/login/index"),
    name: "loginp",
    hidden: true,
  },
  {
    path: "/liveroom",
    component: () => import("@/views/layout/liveroom"),
    name: "liveroom",
    hidden: true,
  },
  {
    path: "/realroom",
    component: () => import("@/views/layout/realroom"),
    name: "realroom",
    hidden: true,
  },
  {
    path: "/roomlist",
    component: () => import("@/views/layout/roomlist"),
    name: "roomlist",
    hidden: true,
  },
  {
    path: "/helps",
    component: () => import("@/views/helps/index"),
    hidden: true,
  },
  {
    path: "/website",
    component: () => import("@/views/website/index"),
    hidden: true,
  },
  {
    path: "/customer",
    component: () => import("@/views/customer/index"),
    hidden: true,
    children: [
      {
        path: "/customer/chat",
        component: () => import("@/views/customer/chat"),
        hidden: true,
      },
    ],
  },
  {
    path: "/designer",
    component: () => import("@/views/marketing/designer"),
    hidden: true,
  },
  {
    path: "/fee",
    component: () => import("@/views/setting/fee"),
    hidden: true,
  },
  {
    path: "/p/planet/live/dashboard",
    name: "LiveDashboard",
    component: (resolve) =>
      require(["@/views/planet/live/dashboard.vue"], resolve),
  },
  {
    path: "/home",
    component: () => import("@/views/website/home"),
    hidden: true,
  },
  {
    path: "/home2",
    component: () => import("@/views/website/home2"),
    hidden: true,
  },
  {
    path: "/download",
    component: () => import("@/views/website/download"),
    hidden: true,
  },
  {
    path: "*",
    component: () => import("@/views/404"),
    hidden: true,
  },
];

console.log(routes);

const router = new VueRouter({
  routes,
});

export default router;

export const asyncRouterMap = asyncRouter;
export const constantRouterMap = routes;
